export namespace RegexFactory {
    export const onlyNumbers = (t: string) => t?.replace(/[^0-9]/g, '');
    export const phoneNumber = (t: string) => {
        const v = RegexFactory.onlyNumbers(t);

        return v?.toString()?.replace(/(\d{2})(\d{2})(\d{1})(\d{4})(\d{4})/, "+$1 ($2) $3 $4-$5");
    }
}